import React, { useEffect } from "react";
import "./About.css";
import Cards from "./Cards";
import { NavLink, Link } from "react-router-dom";
import WAVES from "vanta/src/vanta.waves";
import Preloader from "./Preloader";

const About = () => {
  function blackCoverOn() {
    const blackCover1 = document.getElementById("blackCover1");
    blackCover1.style.display = "inline-block";
  }
  function blackCoverOff() {
    const blackCover1 = document.getElementById("blackCover1");
    blackCover1.style.display = "none";
  }
  useEffect(() => {
    if (document.getElementById("hidden_div") !== null)
      document.getElementById("hidden_div").style.display = "none";
    WAVES({
      el: "#your",
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.0,
      minWidth: 200.0,
      scale: 1.0,
      scaleMobile: 1.0,
      color: "#023047",
      backgroundColor: "#023047",
      shininess: 35.0,
    });
    // console.log("Now....")
    setTimeout(() => {
      const PreLoad = document.getElementById("aboutPreload");
      if (PreLoad) {
        PreLoad.style.display = "none";
        const body = document.getElementsByTagName("body")[0];
        body.style.overflow = "visible";
      }
    }, 2000);
  });
  const ani_block2 = () => {
    const block2 = document.getElementById("block2");
    const aboutInner = document.getElementById("aboutInner");
    const socialMedia = document.getElementById("socialMedia");
    const work = document.getElementById("work");
    const workInner = document.getElementById("workInner");

    if (block2.getBoundingClientRect().top <= window.innerHeight)
      aboutInner.style.transform =
        "perspective(2000px) rotateX(10deg) translateY(-150px)";
    else if (block2.getBoundingClientRect().top > window.innerHeight)
      aboutInner.style.transform = "perspective(2000px) rotateX(10deg)";

    if (socialMedia.getBoundingClientRect().top <= window.innerHeight)
      socialMedia.style.transform = "translateY(-100px)";
    else if (socialMedia.getBoundingClientRect().top > window.innerHeight)
      socialMedia.style.transform = " translateY(-50px)";
    if (work.getBoundingClientRect().top <= window.innerHeight)
      workInner.style.transform = "translateY(-100px)";
    else if (work.getBoundingClientRect().top > window.innerHeight)
      workInner.style.transform = "translateY(0px)";
  };

  return (
    <>
      <Preloader id="aboutPreload" />
      <div id="About" onScroll={ani_block2}>
        <div id="your">
          <div id="intro">
            <div id="name">
              <div style={{ padding: "5px" }}>
                <div style={{ fontSize: "20px", color: "white" }}>
                  Hii, I am{" "}
                </div>
                <div>
                  Pratha<div className="spanDiv">m</div>
                </div>
                <div>
                  <div className="spanDiv">Web </div>
                  Developer
                </div>
                <div style={{ color: "gray" }}>Engineering Student</div>
              </div>
            </div>
            <div id="avtar">
              <div
                id="pratham"
                onMouseOver={blackCoverOn}
                onMouseOut={blackCoverOff}
              ></div>
            </div>
          </div>
          <div id="blackCover1"></div>
        </div>

        <div id="block1"></div>
        <div id="block2">
          <div id="aboutInner">
            <div id="aboutHead">
              <div id="aboutHeadText">About</div>
              <div id="sideBar">
                <div id="upperSideBar">
                  <div id="sideBarBlock1">
                    <div className="shineBar"></div>
                    <div className="shineBar2"></div>
                  </div>
                  <div id="sideBarBlock2">
                    <div className="shineBar"></div>
                  </div>
                </div>
                <div id="bottomSideBar"></div>
              </div>
            </div>
            <div id="aboutContent">
              Hello! My name is Pratham Singh, a Computer Science and
              Engineering student specializing in AI at Pranveer Singh Institute
              of Technology in Kanpur. I am passionate about building innovative
              technology solutions and have completed various projects
              demonstrating my proficiency in web development, AI, and software
              engineering. <br /> <br />
              Professionally, I am currently working as a Python Development
              Intern at Infosys Springboard, where I contribute to real-world
              projects and hone my coding skills. As a Campus Ambassador for
              GeeksforGeeks, I am developing my leadership qualities and
              expanding my network within the tech community. My previous
              internships with IBM and Infosys provided me with valuable
              experience in front-end development and Python training. I have
              worked on a range of projects, including AI-based attendance
              systems, a Google Keep clone, and a portfolio website using
              ReactJS and the MERN stack. Additionally, I have developed a color
              picker Chrome extension, a weather app, and a to-do app using
              various technologies such as HTML5, CSS3, JavaScript, PHP, and
              MySQL. <br /> <br />
              My previous internships with IBM and Infosys provided me with
              valuable experience in front-end development and Python training.
              I have worked on a range of projects, including AI-based
              attendance systems, a Google Keep clone, and a portfolio website
              using ReactJS and the MERN stack. <br /> <br />
              Additionally, I have developed a color picker Chrome extension, a
              weather app, and a to-do app using various technologies such as
              HTML5, CSS3, JavaScript, PHP, and MySQL. My dedication to
              continuous learning and problem-solving has led me to solve over
              670 DSA questions on Leetcode and 230+ on GeeksforGeeks. Connect
              with me on LinkedIn to learn more about my projects and
              professional journey.
            </div>
          </div>
          <div id="socialMedia">
            <ul>
              <li>
                <NavLink
                  to="https://www.linkedin.com/in/pratham-singh-800a0822a/"
                  target="__blank"
                >
                  <img src="LinkedIn.png" alt="" />
                </NavLink>
              </li>
              <li>
                <NavLink to="https://github.com/pratham1singh" target="__blank">
                  <img src="github.png" alt="" />
                </NavLink>
              </li>
              <li>
                <img src="instagram.png" alt="" />
              </li>
              <li>
                <NavLink
                  to="https://leetcode.com/singhpratham191/"
                  target="__blank"
                >
                  <img src="leetcode.png" alt="" />
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div id="work">
          <div id="workInner">
            <Link
              style={{ textDecoration: "none" }}
              target="__blank"
              to="https://www.linkedin.com/posts/pratham-singh-800a0822a_infosysspringboard-infosys-internship-activity-7176556956332036097-AD7f?utm_source=share&utm_medium=member_desktop"
            >
              <Cards
                src="infosys.png"
                text="I During my internship at Infosys, I contributed as a Python developer,
        gaining hands-on experience in software development processes.
        Collaborating within a dynamic team, I honed my skills in coding,
        problem-solving, and software design. I actively participated in
        projects, showcasing my dedication to excellence and passion for
        technology."
              />
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              target="__blank"
              to="https://www.linkedin.com/posts/pratham-singh-800a0822a_i-am-happy-to-share-that-i-have-successfully-activity-7102195494134648832-4qRu?utm_source=share&utm_medium=member_desktop"
            >
              <Cards
                src="ibm.png"
                text="During my virtual internship program with IBM Skill Build, I focused on front-end development over the course of six weeks. 
              This immersive experience allowed me to work on various projects. 
              I gained hands-on experience in project collaboration and  front-end technologies. 
              This internship significantly enhanced my skills in web development and project management."
              />
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              target="__blank"
              to="https://www.linkedin.com/posts/pratham-singh-800a0822a_im-happy-to-share-that-im-starting-a-new-activity-7084810312452874240-JDyo?utm_source=share&utm_medium=member_desktop"
            >
              <Cards
                src="gfg.png"
                text="During my ongoing role as a Campus Ambassador for GeeksforGeeks, I work to build a strong connection between the company and my college community. 
              This  position allows me to enhance my leadership skills and engage with fellow students.
               My involvement has deepened my understanding of effective communication and networking within the tech industry."
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
